import { Component, OnInit, ViewChild } from '@angular/core';
import { _HttpClient, ModalHelper, ModalHelperOptions } from '@delon/theme';
import { NzMessageService } from 'ng-zorro-antd';
import { Router } from '@angular/router';
import {
  STChange,
  STColumn,
  STComponent,
  STData,
  STPage,
  STReq,
  STRequestOptions,
  STRes,
} from '@delon/abc';
import { format } from 'date-fns';
import { DialogService } from 'icc-common-lib';
import { MessageService } from 'icc-common-lib';
import { URLS } from '../../../shared/constant/interface';
import { isJsonString } from '../../../shared/utils/common';
import { getEndDate, getStartDate } from '../../../shared/utils/time';

@Component({
  selector: 'app-leave-message',
  templateUrl: './leave-message.component.html',
  styleUrls: ['./leave-message.component.less'],
})
export class TikTokLeaveMessageComponent implements OnInit {
  constructor(
    private messageService: MessageService,
    private http: _HttpClient,
    private modal: ModalHelper,
    private msgSrv: NzMessageService,
    private router: Router,
    private dialogService: DialogService
  ) {}

  // 自定义组件名
  static NAME = 'icc-msg-comment-message';

  url = URLS.tiktokMoRecord.url;
  expandForm = false;
  isOpenExport = false;
  isOpenContentDetail = false;
  isOpenReplyDetail = false;
  // 当前查看详情的模板
  currentTemplate: any = [];
  amr = null;

  // 回复弹窗相关
  currentUpstream: any = {};
  isOpenReplyDialog = false;
  tabList: Array<any> = [{ title: '文字', content: '' }];
  selectTab = 0;

  detailItem = {
    isMo: true,
    msgType: null,
    content: '',
    type: '',
  };

  options: ModalHelperOptions = {
    /** 大小；例如：lg、600，默认：`lg` */
    size: 'lg',
  };
  @ViewChild('st', { static: false }) st: STComponent;
  columns: STColumn[] = [
    {
      title: '接收抖音号',
      index: 'channelName',
      width: 200,
      className: 'text-center',
    },
    {
      title: '粉丝名称',
      index: 'nickName',
      width: 120,
      className: 'text-center',
    },
    {
      title: 'OpenID',
      index: 'terminalId',
      width: 200,
      className: 'text-center',
    },
    {
      title: '私信类型',
      index: 'content',
      width: 100,
      className: 'text-center',
      format: (item, _col, index) => {
        if (item.content && isJsonString(item.content)) {
          let type = JSON.parse(item.content).message_type;
          let str = '';
          if (type === 'text') {
            str = '文字';
          } else if (type === 'emoji') {
            str = 'emoji';
          }
          return str;
        }
      },
    },
    {
      title: '私信内容',
      width: 200,
      className: 'text-center',
      // index: 'content',
      type: 'link',
      click: (item) => {
        let cJontentJson = JSON.parse(item.content);
        let type = cJontentJson.message_type;
        if (type === 'text') {
          const TiktokModalDetailComponent =
            this.messageService.getModalDetailComponent(
              this.messageService.getMsgTypeByName('tiktok', true)
            );
          if (TiktokModalDetailComponent) {
            this.modal
              .createStatic(
                TiktokModalDetailComponent,
                { title: '私信内容', moContent: cJontentJson.text, isMo: true },
                this.options
              )
              .subscribe(() => {});
          }
        } else if (type === 'emoji') {
          window.open(cJontentJson.resource_url);
        }
        // this.detailItem.type = cJontentJson.message_type;
        // this.detailItem.content = cJontentJson.text;
        // this.isOpenContentDetail = true;
      },
      format: (item, _col, index) => {
        if (item.content && isJsonString(item.content)) {
          let type = JSON.parse(item.content).message_type;
          let str = '';
          if (type === 'text') {
            let text = JSON.parse(item.content).text;
            let length = text.length;
            if (length > 20) {
              text = text.substring(0, 20);
              text += '...';
            }
            str = text;
          } else if (type === 'emoji') {
            str = 'emoji';
          } else {
            str = '【收到不支持的消息类型，暂无法显示】';
          }
          return str;
        }
      },
    },
    {
      title: '私信时间',
      index: 'postTime',
      type: 'date',
      dateFormat: 'yyyy-MM-dd HH:mm:ss',
      width: 200,
      className: 'text-center',
    },

    {
      title: '回复状态',
      index: 'replyState',
      type: 'tag',
      width: 100,
      className: 'text-center',
      tag: {
        0: { text: '未回复', color: 'orange' },
        1: { text: '已回复', color: 'green' },
        2: { text: '已回复', color: 'green' },
      },
    },
    {
      title: '回复内容',
      default: '',
      width: 200,
      className: 'text-center',
      type: 'link',
      click: (item) => {
        // this.detailItem.type = 'text';
        // this.detailItem.content = JSON.parse(item.replyContent)[0].content;
        // this.isOpenReplyDetail = true;
        const TiktokModalDetailComponent =
          this.messageService.getModalDetailComponent(
            this.messageService.getMsgTypeByName('tiktok', true)
          );
        if (TiktokModalDetailComponent) {
          this.modal
            .createStatic(
              TiktokModalDetailComponent,
              { title: '回复内容', mtContent: item.replyContent, isMo: false },
              this.options
            )
            .subscribe(() => {});
        }
      },
      format: (item, _col, index) => {
        if (item.content && isJsonString(item.replyContent)) {
          let str = '';
          let text = JSON.parse(item.replyContent)[0].content.text;
          let length = text.length;
          if (text && text.length > 20) {
            str = text.substring(0, 20) + '...';
          } else {
            str = text;
          }
          return str;
        }
      },
    },
    {
      title: '最近一次回复时间',
      index: 'lastReplyTime',
      type: 'date',
      dateFormat: 'yyyy-MM-dd HH:mm:ss',
      default: '',
      width: 200,
      className: 'text-center',
    },
    {
      title: '操作',
      fixed: 'right',
      width: 80,
      className: 'text-center',
      buttons: [
        {
          text: '回复',
          // acl: { ability: ['msgRecord.moRecord.tiktok.manuallyCallBack'] },
          // iif: (item, btn, column) => {
          //   return item.state === 1 && item.auditResult === 1;
          // },
          click: (item: any) => {
            const { content, postTime, channelName, channelId } = item;
            this.currentUpstream = { postTime, channelName, channelId };
            const parseContent = JSON.parse(content);
            if (parseContent.message_type === 'voice') {
              parseContent.content =
                URLS.attachment.url + '?' + parseContent.content;
            } else if (parseContent.message_type === 'image') {
              parseContent.content =
                URLS.attachment.url + '?' + parseContent.content;
            } else if (parseContent.message_type === 'video') {
              parseContent.content =
                URLS.attachment.url + '?' + parseContent.content;
            } else if (parseContent.message_type === 'text') {
              parseContent.content = parseContent.text;
            }
            this.currentUpstream.type = parseContent.message_type;
            this.currentUpstream.content = parseContent.content;
            this.customerCode = item.customerCode;
            this.msgId = item.ticketId;
            this.replyContent = '';
            this.openReplyDialog();
          },
        },
      ],
    },
  ];
  req: STReq = {
    method: 'POST',
    allInBody: true,
    body: {
      params: {
        nickName: '',
        terminalId: '',
        channelName: '',
        // contentType: '',
        replyState: -1,
        start: format(getStartDate(new Date(), 7), 'yyyy-MM-dd HH:mm:ss'),
        end: format(getEndDate(new Date(), 0), 'yyyy-MM-dd HH:mm:ss'),
      },
    },
    process: (requestOptions: STRequestOptions) => {
      return requestOptions;
    },
  };

  page: STPage = {
    zeroIndexed: true,
  };
  res: STRes = {};
  // 选中的数据
  selectedRows: STData[] = [];

  /*searchOptions*/
  searchOptions: any = {
    nickName: '',
    terminalId: '',
    channelName: '',
    dateRange: [getStartDate(new Date(), 7), getEndDate(new Date(), 0)],
    // contentTypes: {
    //   contentType: '',
    //   list: [{ label: '全部', value: '' }, { label: '语音', value: 'voice' }, { label: '图片', value: 'image' }, { label: '文字', value: 'text' }, { label: '视频', value: 'video' }, { label: '地理位置', value: 'location' }, { label: '链接', value: 'link' }],
    // },
    replyState: {
      status: -1,
      list: [
        { label: '全部', value: -1 },
        { label: '未回复', value: 0 },
        { label: '已回复', value: 1 },
      ],
    },
  };

  // 等待导出的文件路径列表
  waitingExportFiles: any = [];
  // 存放时间，用于过期
  waitingExportFilesMap: { [key: string]: Date } = {};
  downloadPath = URLS.attachment.url + '?module=17&attach=2&path=';
  // 过期时间 10分钟
  expiredTime = 10 * 60 * 60 * 1000;

  /** 回复消息开始**/
  replyMsg = {
    id: '',
    content: '',
  };

  replyContent = '';
  msgId;

  /** 回复消息结束**/

  customerCode;

  _handleClose() {
    this.isOpenContentDetail = false;
    this.isOpenReplyDetail = false;
    // 关闭音频播放
    if (this.amr != null) {
      this.amr.stop();
      this.amr = null;
    }
  }

  stChange(e: STChange) {
    switch (e.type) {
      case 'checkbox':
        this.selectedRows = e.checkbox!;
        break;
      case 'filter':
        this.st.reload();
        break;
    }
  }

  ngOnInit() {
    this.detailItem = {
      isMo: true,
      msgType: this.messageService.getMsgTypeByName('tiktok', true),
      content: '',
      type: '',
    };
  }

  getTableList() {
    this.st.reset({
      params: {
        // providerName: this.searchOptions.providerName,
        nickName: this.searchOptions.nickName,
        terminalId: this.searchOptions.terminalId,
        channelName: this.searchOptions.channelName,
        // contentType: this.searchOptions.contentTypes.contentType,
        replyState: this.searchOptions.replyState.status,
        start:
          this.searchOptions.dateRange.length >= 1
            ? format(this.searchOptions.dateRange[0], 'yyyy-MM-dd HH:mm:ss')
            : null,
        end:
          this.searchOptions.dateRange.length >= 2
            ? format(this.searchOptions.dateRange[1], 'yyyy-MM-dd HH:mm:ss')
            : null,
      },
    });
  }

  resetTableList() {
    // 重置搜索条件
    // this.searchOptions.providerName = '';
    this.searchOptions.nickName = '';
    this.searchOptions.terminalId = '';
    this.searchOptions.channelName = '';
    this.searchOptions.dateRange = [
      getStartDate(new Date(), 7),
      getEndDate(new Date(), 0),
    ];
    // this.searchOptions.contentTypes.contentType = '';
    (this.searchOptions.replyState.status = -1),
      // 重新加载table数据
      this.getTableList();
  }

  goExport() {
    this.router.navigateByUrl('/system/import-export/export');
  }

  closeExport() {
    this.isOpenExport = false;
  }

  export() {
    // 判断前端表格是否有数据，如果没有，则直接返回“无数据可导出”
    if (!this.st._data || this.st._data.length === 0) {
      this.dialogService.notification.warning('导出', '无数据可导出');
      return;
    }
    this.http
      .post(URLS.tiktokMoRecordExport.url, {
        // 需要修改为抖音接口
        params: {
          providerName: this.searchOptions.providerName,
          terminalId: this.searchOptions.terminalId,
          channelName: this.searchOptions.channelName,
          replyState: this.searchOptions.replyState.status,
          start:
            this.searchOptions.dateRange.length >= 1
              ? format(this.searchOptions.dateRange[0], 'yyyy-MM-dd HH:mm:ss')
              : null,
          end:
            this.searchOptions.dateRange.length >= 2
              ? format(this.searchOptions.dateRange[1], 'yyyy-MM-dd HH:mm:ss')
              : null,
        },
      })
      .subscribe((res) => {
        if (res.status === 0) {
          this.isOpenExport = true;
          this.waitingExportFiles.push(res.data);
          this.waitingExportFilesMap[res.data] = new Date();
        } else {
          this.dialogService.notification.error('导出', res.errorMsg);
        }
      });
  }

  ngOnDestroy() {}

  // 回复弹窗
  openReplyDialog() {
    this.replyContent = '';
    this.isOpenReplyDialog = true;
  }

  closeReplyDialog() {
    this.msgId = '';
    this.replyContent = '';
    this.isOpenReplyDialog = false;
  }

  // 回复弹窗 - 确认
  ensureReplyDialog(): void {
    if (!this.replyContent) {
      this.msgSrv.error('请输入回复内容', {
        nzDuration: 3000,
      });
      return;
    }
    this.replyMsg.id = this.msgId;

    this.replyMsg.content = this.replyContent;

    // 关闭弹窗。
    this.closeReplyDialog();
    this.msgId = '';
    this.replyContent = '';

    // 提交到后台
    this.http
      .post(URLS.smsMoRecordManuallyCallBack.url, this.replyMsg)
      .subscribe((res) => {
        if (res.status === 0) {
          this.msgSrv.success('回复成功');
          // 重新加载table数据
          this.getTableList();
        } else {
          this.msgSrv.error('回复失败，' + res.errorMsg);
        }
      });
  }

  // 回复弹窗 - 取消
  cancelReplyDialog(): void {
    this.msgId = '';
    this.replyContent = '';
    this.closeReplyDialog();
  }

  // 跳转到时光轴
  gotoTimeLine(): void {
    if (!this.customerCode) {
      this.msgSrv.error('当前用户非通讯录中用户，暂不可查询');
      return;
    }
    this.router.navigateByUrl(
      '/msgRecord/timeRecord?customerCode=' + this.customerCode
    );
  }

  // 设置开始时间为00:00:00 结束时间为23:59:59
  onOkDate() {
    if (this.searchOptions.dateRange[0]) {
      // 设置开始时间为选择日期的 00:00:00
      this.searchOptions.dateRange[0] = new Date(
        new Date(
          new Date(this.searchOptions.dateRange[0]).toLocaleDateString()
        ).getTime()
      );
    }
    if (this.searchOptions.dateRange[1]) {
      // 设置开始时间为选择日期的 23:59:59
      this.searchOptions.dateRange[1] = new Date(
        new Date(
          new Date(this.searchOptions.dateRange[1]).toLocaleDateString()
        ).getTime() +
          24 * 60 * 60 * 1000 -
          1
      );
    }
  }
}
